import React from 'react';
import jQuery from 'jquery';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ZInput } from 'components/widgets/ZElements';

import '../styles/dialog.less';
import '../styles/email-dialog.less';
import '../styles/info-dialog.less';
import '../styles/error-dialog.less';

export default class Dialog extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    email: PropTypes.string,
    emailErr: PropTypes.string,
    pinErr: PropTypes.string,
    errTitle: PropTypes.string,
    errMessage: PropTypes.string,
    handleEditEmailSubmit: PropTypes.func,
    handleExit: PropTypes.func
  };

  state = {
    submitted: false
  };

  componentDidMount() {
    //todo: I don't know if this is correct
    jQuery('#container').addClass('disable-scroll');
  }

  componentWillUnmount() {
    jQuery('#container').removeClass('disable-scroll');
  }

  onSubmitClicked = () => {
    this.setState({ submitted: true });
  };

  renderBorder(title) {
    return (
      <div className="section-border web">
        <div className="section-title web info">{title}</div>
      </div>
    );
  }

  renderInfoPopUp(title, message) {
    return (
      <div id="info-popup">
        {this.renderBorder(title)}
        <div className="message">{message}</div>
        <div className="button-container">
          <button className="button" onClick={this.props.handleExit}>
            Proceed
          </button>
        </div>
      </div>
    );
  }

  renderEmailPopUp() {
    let email = this.props.email ? this.props.email : '';
    let emailErr = this.props.emailErr ? this.props.emailErr : '';
    let pinErr = this.props.pinErr ? this.props.pinErr : '';

    let formFieldClassNames = classNames('form-field', {
      submitted: this.state.submitted
    });
    return (
      <div id="email-popup">
        <a className="cancel" onClick={this.props.handleExit} />
        {this.renderBorder('Update Your Email Address')}

        <div className="form-container">
          <form
            className="form"
            onSubmit={this.props.handleEditEmailSubmit}
            autoComplete="off"
          >
            <fieldset>
              <legend>{email}</legend>
              <div className={formFieldClassNames}>
                <label>New Email</label>
                <ZInput
                  className="form-input"
                  type="email"
                  ref="email"
                  error="A valid email is required."
                  customError={emailErr}
                  required
                  errorMessageVisible
                />
              </div>

              <div className={formFieldClassNames}>
                <label>Pin</label>
                <ZInput
                  className="form-input"
                  password
                  type="tel"
                  ref="pin"
                  pattern="\d{6}"
                  maxLength="6"
                  error="Pin must be exactly 6 digits"
                  customError={pinErr}
                  required
                  errorMessageVisible
                />
              </div>

              <div className="form-field center">
                <input
                  className="button"
                  type="submit"
                  value="Update Email"
                  onClick={this.onSubmitClicked}
                />
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }

  renderErrorPopUp(title, message) {
    return (
      <div id="error-popup">
        <div className="title">{title}</div>
        <div className="message">{message}</div>
        <div className="button-container">
          <button className="button" onClick={this.props.handleExit}>
            Ok
          </button>
        </div>
      </div>
    );
  }

  render() {
    let body;
    switch (this.props.type) {
      case 'update-email':
        body = this.renderEmailPopUp();
        break;
      case 'complete-reg':
        body = this.renderInfoPopUp(
          'Complete Your Registration',
          'Please complete your registration by filling up the missing fields under "Personal Information"'
        );
        break;
      case 'error': {
        let title = this.props.errTitle ? this.props.errTitle : '';
        let message = this.props.errMessage ? this.props.errMessage : '';
        body = this.renderErrorPopUp(title, message);
        break;
      }
      default:
        break;
    }
    return (
      <div id="dialog">
        <div className="overlay" />
        <div className="content">{body}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/widgets/Dialog.js